
import { defineComponent } from 'vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { addMessageQueue, MESSAGE_TYPE_ERROR } from '@/plugins/messageQueue'
import Message from '@/services/message'
import { Geocoder } from '@/services/googleMap'

/**
 * 住所から座標を取得するコンポーネント
 * 文字列の座標を返す
 */
export default defineComponent({
  name: 'JrGeocoder',
  emits: ['update:lat', 'update:lng', 'change'],
  components: {
    JrButton,
  },
  props: {
    address: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    return {
      search: async () => {
        if (props.address === '') {
          addMessageQueue(MESSAGE_TYPE_ERROR, Message.bind(Message.codes.V_REQUIRED, { attribute: '住所' }))
          return
        }
        const geocoder = new Geocoder()
        const latLng = await geocoder.search(props.address)
        if (latLng === null) {
          // 住所から座標の取得失敗
          context.emit('update:lat', '')
          context.emit('update:lng', '')
          addMessageQueue(MESSAGE_TYPE_ERROR, Message.codes.GEOCODER_ADDRESS_NOT_FOUND)
        } else {
          context.emit('update:lat', latLng.lat.toPrecision(9))
          context.emit('update:lng', latLng.lng.toPrecision(9))
          context.emit('change')
        }
      },
    }
  },
})
